/* hs-eslint ignored failing-rules */
'use es6';

import ActionTypes from './ActionTypes';
import { UPWORK_LOCAL_STORAGE_KEY } from '../constants/CourseConstants';
import { BASE_URI } from '../constants/ApiConstants';
import http from 'hub-http/clients/apiClient';
const UPWORK_URI = `${BASE_URI}/upwork/send`;
export function toggleAutoPlay() {
  return {
    type: ActionTypes.TOGGLE_AUTO_PLAY
  };
}
export function setVideoPlaySpeed(playSpeed) {
  return {
    type: ActionTypes.SET_VIDEO_PLAY_SPEED,
    playSpeed
  };
}
export function setSelectedCategories(categories) {
  return {
    type: ActionTypes.SET_SELECTED_CATEGORIES,
    payload: categories
  };
}
export function setSelectedAwardFilter(userProgress) {
  return {
    type: ActionTypes.SET_SELECTED_AWARD_FILTER,
    payload: userProgress
  };
}
export function setSelectedUserProgressFilter(award) {
  return {
    type: ActionTypes.SET_SELECTED_USER_PROGRESS_FILTER,
    payload: award
  };
}
export function clearAllFilters() {
  return {
    type: ActionTypes.CLEAR_ALL_FILTERS
  };
}

function upworkLocalStorageMergeFunction(currentLocalStorageState, idToAdd) {
  return [...(currentLocalStorageState || []), idToAdd];
}

function sendToUpworkRequesting() {
  return {
    type: ActionTypes.SEND_TO_UPWORK_REQUESTING
  };
}

function sendToUpworkReceived(trackId) {
  return {
    type: ActionTypes.SEND_TO_UPWORK_REQUEST_SUCCESS,
    payload: trackId,
    meta: {
      persistence: {
        storageKey: UPWORK_LOCAL_STORAGE_KEY,
        mergeFunction: upworkLocalStorageMergeFunction
      }
    }
  };
}

function sendToUpworkRequestError(error) {
  return {
    type: ActionTypes.SEND_TO_UPWORK_REQUEST_ERROR,
    error: true,
    payload: error
  };
}

export function sendToUpwork(trackId) {
  return dispatch => {
    dispatch(sendToUpworkRequesting());
    http.post(`${UPWORK_URI}/${trackId}`).then(() => dispatch(sendToUpworkReceived(trackId)), errorResponse => dispatch(sendToUpworkRequestError(errorResponse))).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}